import { useEffect, useState } from "react";

/**
 * A live clock for time-boundary UI — a lead-time nag lighting up, a
 * submission window closing — that would otherwise only recompute when a
 * query actually refetches (a manual reload, window refocus, or an
 * unrelated mutation invalidating the same keys). Without this, a
 * long-mounted component can hold a stale answer indefinitely across a
 * boundary that time alone crosses.
 *
 * Ticks every `intervalMs` (default one minute — plenty for a day/hour-scale
 * boundary) for as long as the component stays mounted.
 */
export function useNowTick(intervalMs = 60_000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}
